import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { CataloghiBlock as Original } from 'components/molecules'
import { CataloghiBlockSettings, CataloghiBlockFloatingSettings } from './CataloghiBlockSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { getTextEditor } from '../TextEditor'
import { getItemChildren } from 'react-pagebuilder/utils/node'
import { downloadLinkItemParams } from '../DownloadLink'

export const defaultProps = {}

export const cataloghiBlockItemParams = (enabled, id, blockProps, children) => ({
  pk: id,
  name: getTextEditor(children?.[0], enabled),
  children: getItemChildren(enabled, children?.[1], downloadLinkItemParams),
})

export const dynamicProps = []

export const CataloghiBlock: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled } = useEditor(
      (state) => ({
        enabled: state.options.enabled,
      }),
      props
    )

    return (
      <div ref={(ref) => props.retRef(ref)} className={`block-cataloghi-block ${props.className}`}>
        <Original
          item={cataloghiBlockItemParams(enabled, id, blockProps, children)}
          editMode={enabled}
        />
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

CataloghiBlock.craft = withCraft({
  name: 'CataloghiBlock',
  defaultProps: defaultProps,
  settings: CataloghiBlockSettings,
  floatingSettings: CataloghiBlockFloatingSettings,
})
